import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockQCEntries } from '../data/mockData';
import { QCEntry } from '../types';
export function DisposalRepairList() {
  const navigate = useNavigate();
  const columns: Column<QCEntry>[] = [{
    key: 'qcReferenceNo',
    label: 'QC Ref No',
    render: q => <span className="font-medium text-indigo-600" data-id="element-717">{q.qcReferenceNo}</span>
  }, {
    key: 'product',
    label: 'Product/Item'
  }, {
    key: 'warehouse',
    label: 'Warehouse'
  }, {
    key: 'rejectedQty',
    label: 'Rejected Qty',
    render: q => <span className="text-red-600 font-medium" data-id="element-718">{q.rejectedQty}</span>
  }, {
    key: 'qcStatus',
    label: 'Status',
    render: q => <StatusBadge status={q.qcStatus} data-id="element-719" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-720">
      <div className="flex items-center justify-between" data-id="element-721">
        <div data-id="element-722">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-723">
            Disposal & Repair
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-724">
            Manage rejected items from Quality Control.
          </p>
        </div>
      </div>

      <div className="flex-1" data-id="element-725">
        <DataTable columns={columns} data={mockQCEntries.filter(q => q.rejectedQty > 0)} keyExtractor={item => item.id} searchPlaceholder="Search rejected items..." onRowClick={item => navigate(`/disposal-repair/${item.id}`)} actions={item => <div className="flex space-x-3 justify-end" data-id="element-727">
              <button onClick={() => navigate(`/disposal-repair/${item.id}`)} className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50" data-id="element-728">
                <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-729" /> Action
              </button>
            </div>} data-id="element-726" />
      </div>
    </div>;
}